import {SyncDevice} from "../../domain/sync/SyncDevice";
import appDB from "../persistence/indexed-db";

const deleteSyncDevice = (deviceUUID: SyncDevice['uuid']) => {
    return appDB.syncable.delete(deviceUUID)
}

export default deleteSyncDevice;